import * as React from "react";
import { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase-config";
import {
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Box,
  Flex,
  Stack,
  Heading,
  Text,
  Container,
  Input,
  Button,
  SimpleGrid,
  Avatar,
  AvatarGroup,
  useBreakpointValue,
  IconProps,
  Icon,
} from "@chakra-ui/react";

import { useCookies } from "react-cookie";
import { Link, useNavigate } from "react-router-dom";
import UpChildFooter from "../components/CustomFooter";

const avatars = [
  {
    name: "Ryan Florence",
    url: "https://bit.ly/ryan-florence",
  },
  {
    name: "Segun Adebayo",
    url: "https://bit.ly/sage-adebayo",
  },
  {
    name: "Kent Dodds",
    url: "https://bit.ly/kent-c-dodds",
  },
  {
    name: "Prosper Otemuyiwa",
    url: "https://bit.ly/prosper-baba",
  },
  {
    name: "Christian Nwamba",
    url: "https://bit.ly/code-beast",
  },
];

function Login() {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [user, setUser] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  }, [auth]);

  const login = async () => {
    console.log("in login func");
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        loginEmail,
        loginPassword
      );
      setCookie("user", user, {
        path: "/",
      });
      navigate("/dashboard");
      console.log(user.user.uid);
    } catch (error) {
      document.getElementById("errorMsg").innerHTML = error.message;
      console.log(error.message);
    }
  };

  const logout = async () => {
    await signOut(auth);
    navigate("/");


  };

  return (
    <Box position={"relative"}>
      <Container
        as={SimpleGrid}
        maxW={"7xl"}
        columns={{ base: 1, md: 2 }}
        spacing={{ base: 10, lg: 32 }}
        py={{ base: 10, sm: 20, lg: 32 }}
      >
        <Stack spacing={{ base: 10, md: 20 }} mt={10}>
          <Heading
            lineHeight={1.1}
            fontSize={{ base: "2xl", sm: "3xl", md: "4xl", lg: "5xl" }}
          >
            Upchild Foundation Volunteers
          </Heading>
          <Stack direction={"row"} spacing={4} align={"center"}>
            <AvatarGroup>
              {avatars.map((avatar) => (
                <Avatar
                  key={avatar.name}
                  name={avatar.name}
                  src={avatar.url}
                  //   size={useBreakpointValue({base: "md",md: "lg",})}
                  position={"relative"}
                  zIndex={2}
                  _before={{
                    content: '""',
                    width: "full",
                    height: "full",
                    rounded: "full",
                    transform: "scale(1.125)",
                    bgColor: "#8DC63F",
                    position: "absolute",
                    zIndex: -1,
                    top: 0,
                    left: 0,
                  }}
                />
              ))}
            </AvatarGroup>
            <Text fontFamily={"heading"} fontSize={{ base: "4xl", md: "6xl" }}>
              +
            </Text>
            <Flex
              align={"center"}
              justify={"center"}
              fontFamily={"heading"}
              fontSize={{ base: "sm", md: "lg" }}
              bg={"gray.800"}
              color={"white"}
              rounded={"full"}
              minWidth={useBreakpointValue({ base: "44px", md: "60px" })}
              minHeight={useBreakpointValue({ base: "44px", md: "60px" })}
              position={"relative"}
              _before={{
                content: '""',
                width: "full",
                height: "full",
                rounded: "full",
                transform: "scale(1.125)",
                bgGradient: "linear(to-bl, teal.400,#8DC63F)",
                position: "absolute",
                zIndex: -1,
                top: 0,
                left: 0,
              }}
            >
              YOU
            </Flex>
          </Stack>
        </Stack>
        <Stack
          bg={"gray.50"}
          rounded={"xl"}
          p={{ base: 4, sm: 6, md: 8 }}
          spacing={{ base: 8 }}
          maxW={{ lg: "lg" }}
        >
          <Stack spacing={4}>
            <Heading
              color={"gray.800"}
              lineHeight={1.1}
              fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
            >
              Login to the Account
              <Text
                as={"span"}
                bgGradient="linear(to-r, teal,teal)"
                bgClip="text"
              >
                !
              </Text>
            </Heading>
            <Text color={"gray.500"} fontSize={{ base: "sm", sm: "md" }}>
              Use your credentials to access the account
            </Text>

            <Text
              id="errorMsg"
              color={"red.500"}
              fontSize={{ base: "sm", sm: "md" }}
            ></Text>
          </Stack>
          <Box as={"form"} mt={10}>
            <Stack spacing={4}>
              <Input
                placeholder="help@upChild.com"
                bg={"gray.100"}
                value={loginEmail}
                onChange={(event) => {
                  setLoginEmail(event.target.value);
                }}
                border={0}
                color={"gray.500"}
                _placeholder={{
                  color: "gray.500",
                  isRequire: true,
                }}
              />
              <Input
                placeholder="Password"
                onChange={(event) => {
                  setLoginPassword(event.target.value);
                }}
                type="password"
                value={loginPassword}
                bg={"gray.100"}
                border={0}
                color={"gray.500"}
                _placeholder={{
                  color: "gray.500",
                  isRequired: true,
                }}
              />
            </Stack>
            <Button
              onClick={login}
              mt={8}
              w={"full"}
              colorScheme="teal"
              color={"white"}
              _hover={{
                bgGradient: "linear(to-r, #8DC63F,#8DC63F)", //add theme extender for better effects
                boxShadow: "xl",
              }}
            >
              Submit
            </Button>
            <h4> User Logged In: </h4>
            {user?.email}

            <button onClick={logout}> Sign Out </button>
          </Box>
          form
        </Stack>
      </Container>
      <UpChildFooter />
      <Blur
        position={"absolute"}
        top={-10}
        left={-10}
        style={{ filter: "blur(70px)" }}
      />
    </Box>
  );
}

const Blur = (props: IconProps) => {
  return (
    <Icon
      width={useBreakpointValue({ base: "100%", md: "40vw", lg: "30vw" })}
      zIndex={useBreakpointValue({ base: -1, md: -1, lg: 0 })}
      height="560px"
      viewBox="0 0 528 560"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="71" cy="61" r="81" fill="#8DC63F" />
      <circle cx="244" cy="106" r="89" fill="#8DC63F" />
      <circle cy="291" r="89" fill="#8DC63F" />
      <circle cx="80.5" cy="189.5" r="61.5" fill="#8DC63F" />
      <circle cx="196.5" cy="317.5" r="61.5" fill="#8DC63F" />
      <circle cx="70.5" cy="458.5" r="61.5" fill="#8DC63F" />
      <circle cx="426.5" cy="-0.5" r="61.5" fill="#8DC63F" />
    </Icon>
  );
};

export default Login;
